import React, { useContext, useMemo } from 'react';
import IndentFieldsContext from './IndentFieldsContext';
import styles from './indentFields.module.scss';
var disabledContext = {
  enabled: false,
  level: 0
};
export default function useIndentFields() {
  var currentContext = useContext(IndentFieldsContext);
  var enabled = currentContext.enabled,
    level = currentContext.level;
  return useMemo(function () {
    return {
      enabled: enabled,
      indentClassName: enabled ? styles["level-".concat(level)] : '',
      indentRightClassName: enabled ? styles["level-".concat(level, "--right")] : '',
      currentContext: currentContext,
      parentContext: {
        enabled: enabled,
        level: level - 1
      },
      childContext: {
        enabled: enabled,
        level: level + 1
      },
      disabledContext: disabledContext
    };
  }, [currentContext, enabled, level]);
}